import React from 'react';
import { bundles } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const BundlesSection = ({ addToCart }) => {
  return (
    <section id="bundles" className="py-24 md:py-32 px-6 md:px-12 bg-white">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#2C2C2C] mb-6">Curated Bundles</h2>
            <p className="text-[#595959] text-base md:text-lg font-light leading-relaxed">
              Thoughtfully paired pieces designed to work together beautifully, offered at a special set price to complete your space.
            </p>
          </div>
          <a href="#" className="nav-link text-sm tracking-[0.15em] uppercase text-[#2C2C2C] pb-1 hover:text-[#8B7355] transition-colors whitespace-nowrap font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8B7355] rounded-sm">
            View All Sets
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {bundles.map((bundle) => (
            <div key={bundle.id} className="group flex flex-col">
              <div className="relative aspect-[4/5] bg-[#F9F8F6] overflow-hidden mb-6 rounded-sm">
                {bundle.tag && (
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-1.5 text-[10px] tracking-[0.2em] uppercase z-10 text-[#2C2C2C] font-medium shadow-sm">
                    {bundle.tag}
                  </div>
                )}
                <picture>
                  <source 
                    type="image/webp" 
                    srcSet={`${bundle.image}&w=400&q=80 400w, ${bundle.image}&w=800&q=80 800w`} 
                    sizes="(max-width: 768px) 100vw, 33vw" 
                  />
                  <img 
                    src={`${bundle.image}&w=800&q=80`} 
                    alt={`Coordinated bundle: ${bundle.name}`} 
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-[1.05]"
                    width="800"
                    height="1000"
                  />
                </picture>
                
                {/* Quick Add Overlay */}
                <div className="absolute inset-x-0 bottom-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex md:block">
                  <button 
                    onClick={() => addToCart(bundle)}
                    aria-label={`Quick add ${bundle.name} to cart`}
                    className="w-full bg-[#2C2C2C]/95 backdrop-blur-md text-white py-4 text-xs tracking-[0.15em] uppercase flex items-center justify-center gap-2 hover:bg-black transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8B7355] focus-visible:ring-offset-2"
                  >
                    <SafeIcon icon={FiIcons.FiShoppingBag} className="w-4 h-4" />
                    Quick Add
                  </button>
                </div>
              </div>
              
              <div className="text-center px-4 mt-auto">
                <h3 className="text-lg md:text-xl font-serif text-[#2C2C2C] mb-3 group-hover:text-[#8B7355] transition-colors">{bundle.name}</h3>
                <div className="flex justify-center gap-3 items-center text-sm">
                  <span className="text-[#2C2C2C] font-medium">${bundle.price}</span>
                  <span className="text-[#A3A3A3] line-through">${bundle.originalPrice}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BundlesSection;